export default __webpack_public_path__ + "static/media/trolley-boys.6414f00c.jpg";